import { useGlobalNotification } from 'hooks';
import { NotificationItem, NotificationItemForm } from 'queries/notifications/contract';

import {
  useAddNotificationMutation,
  useEditNotificationMutation,
} from 'queries/notifications/queries';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const defaultValues = {
  email: true,
  whatsapp: false,
  asset_id: undefined,
  model_id: undefined,
  frequency: 'DAILY',
};

const useNotificationForm = () => {
  const [editingId, setEditingId] = useState<string>();
  const { t } = useTranslation();
  const formMethods = useForm<NotificationItemForm>({ values: defaultValues });
  const { displaySnackbar } = useGlobalNotification();
  const onEdit = (originalData: NotificationItem) => {
    setEditingId(originalData.id);
    formMethods.reset({ ...defaultValues, ...originalData });
  };

  const onSucess = async (data: void, variables: NotificationItem) => {
    const type = variables.id ? 'edit' : 'create';
    displaySnackbar({
      message: t(`messages:${type}.message`, { item: t('components:notifications.item') }),
      type: 'success',
    });

    setEditingId(undefined);

    formMethods.reset({ ...defaultValues, asset_id: variables.asset_id });
  };
  const { mutate: editMutate, isLoading: isEditMutating } = useEditNotificationMutation(onSucess);
  const { mutate: addMutate, isLoading: isAddMutating } = useAddNotificationMutation(onSucess);

  const onSubmit = formMethods.handleSubmit((data) =>
    data.id ? editMutate(data) : addMutate(data),
  );
  return {
    onSubmit,
    isMutating: isEditMutating || isAddMutating,
    formMethods,
    onEdit,
    editingId,
  };
};

export default useNotificationForm;
